import { Button, PopConfirm } from '@roo/roo';
import React, { useEffect, useState } from 'react';
import {
  queryJudgeResult,
  beginJudge,
  saveJudgeResult,
  queryGroupStatus,
} from '@assets/apis/review';
import { toastFail, toastSuccess } from '@utils/utils';
import { useQuery } from '@hooks/query';
import { ApplyViewPage } from '@pages/applyView';
import { getSimpleContext } from '@pages/applyView/_utils/simple';
import Header from '../HeaderWithoutMenu';
import ReviewForm from './ReviewForm';
import { JudgeStatus, OperatorType } from './reviewTypes';
import Guide from './Guide/Guide';

import './detail.less';

// 待评审
const StartVote = ({ action, groupId }) => {
  const [groupStatus, setGroupStatus] = useState(null);

  useEffect(() => {
    queryGroupStatus(groupId).then((res) => {
      setGroupStatus(res.status);
    }).catch((err) => {
      console.log(err);
    });
  }, []);

  // 待确认
  if (groupStatus === 0) {
    return (
      <div className="state-1">
        <p className="state-1__title">
          感谢您对青山科技奖的支持，评审暂未正式开始，请耐心等待。
        </p>
        <div className="state-1__desc">
          <p>评审开始时，秘书处将通过邮件形式正式通知，烦请您注意查收邮件。</p>
          <p>如有任何疑问，请联系青山科技奖秘书处010-56114793，huanbao@meituan.com</p>
        </div>
        <Button disabled>开启评审</Button>
      </div>
    );
  }

  return (
    <div className="state-1">
      <p className="state-1__title">
        感谢您对美团青山科技奖的支持，您可点击下方按钮正式进入评审环节。
      </p>
      <div className="state-1__desc">
        <p>评审流程说明：</p>
        <p>
          1.青山科技奖评审分为形式审查、初评、终审答辩三阶段。初评采用网络评审形式，评审专家不集中交流讨论，
          <strong>独立打分并限额投票，评审时间以邮件通知为准。</strong>
          通过初评产生进入终审答辩环节的候选人。
        </p>
        <p>2.青山科技奖的申请、评审和授奖，严格遵循公平、公正、公开的原则，实行科学的评审制度，杜绝任何组织或个人超越章程地干涉评奖过程行为。</p>
        <p>
          3.评委专家在评审过程中需综合考察申报人“
          <strong>过往成就、工作规划、未来潜力</strong>
          ”三阶段和“
          <strong>学术研究、创新研发、影响贡献</strong>
          ”三维度，进行综合考量。
        </p>
        <p>4.各评审组申报人数量较多，您可在评审过程中保存草稿，分多次完成评审，一旦提交则不支持修改，请谨慎操作。</p>
        <p>5.如有任何疑问，请联系青山科技奖秘书处010-56114793，huanbao@meituan.com</p>
      </div>
      <PopConfirm content="确认开启评审吗？" onConfirm={action}>
        <Button>开启评审</Button>
      </PopConfirm>
    </div>
  );
};

// 评审中
function Vote(props) {
  const { data, action, putDetail } = props;
  const disabled = !!(data && data.judgeStatus === JudgeStatus.TIMEOUT);
  const propScore = 'score' in data.judgeResult ? data.judgeResult.score : 0;

  return (
    <div className="state-2" style={{ height: '100%' }}>
      <div>
        {data.judgeResult ? (
          <ReviewForm
            detail={data}
            disabled={disabled}
            score={propScore}
            putDetail={putDetail}
            action={action}
          />
        ) : (
          <>-</>
        )}
      </div>
    </div>
  );
}

// 通过
const ViewVote = function ({ data }) {
  const propScore = 'score' in data.judgeResult ? data.judgeResult.score : 0;
  const Delegation = data.operatorType === OperatorType.Delegation ? <span>（评委授权运营代评审）</span> : '';

  return (
    <div className="state-3">
      <p className="judge">
        <span className="judge__label">评委</span>
        <span>
          {data.judger}
          {Delegation}
        </span>
      </p>
      <p className="time">
        <span className="time__label">提交时间</span>
        <span>{data.submitTime}</span>
      </p>
      <div className="res">
        <span className="res__label">评审结论</span>
        {data.judgeResult ? (
          <ReviewForm detail={data} score={propScore} disabled />
        ) : (
          <>-</>
        )}
      </div>
    </div>
  );
};

const Detail = function (props) {
  const query = useQuery();
  const [error, setError] = useState();
  const { state: detailState } = useSimpleContext((t) => t.hasReview);
  const projectNo = props.match.params.projectNo;
  const id = query.get('reviewId');
  const groupId = query.get('groupId');
  const roundId = query.get('roundId');
  const projectType = +query.get('projectType');
  const [detail, setDetail] = useState({ projectNo, projectType });

  const queryRes = async () => {
    try {
      const res = await queryJudgeResult({ groupId, roundId, projectNo });
      setDetail({ ...res, projectNo });
    } catch (err) {
      setError(err);
    }
  };

  useEffect(() => {
    if (!detailState.hasReview) {
      return;
    }
    queryRes();
  }, []);

  const actionJudge = async () => {
    try {
      await beginJudge({ groupId, roundId, projectNo });
      queryRes();
    } catch (err) {
      console.log(err);
    }
  };

  const actionSave = async (type) => {
    if (!detail.judgeResult) {
      toastFail('缺少评审文件');
      return false;
    }

    if (detail.otherJudgeInfo?.length > 2000) {
      toastFail('评审意见不能超过 2000 字');
      return false;
    }

    try {
      await saveJudgeResult({
        groupId,
        roundId,
        projectNo,
        id: detail.id,
        judgeResult: detail.judgeResult,
        otherJudgeInfo: detail.otherJudgeInfo,
        judgeStatus: type,
      });
      queryRes();
      toastSuccess('保存成功');
    } catch (err) {
      console.log(err);
    }
  };

  const putDetail = (data) => {
    setDetail(data);
  };

  if (error) {
    return (
      <div>
        <Header plate="评审平台" />
        <div className="page-detail" style={{ marginTop: 60 }}>
          <div className="error">{error}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="detail">
      {detailState.hasReview && <Guide />}
      <ApplyViewPage
        isViewType
        projectNo={detail?.projectNo}
        projectType={detail?.projectType}
      >
        <div className="detail__review detail__review__layout">
          {detail.judgeStatus === JudgeStatus.NOT_START ? (
            <StartVote action={actionJudge} groupId={groupId} />
          ) : null}
          {[JudgeStatus.VOTING, JudgeStatus.TIMEOUT].includes(detail.judgeStatus) ? (
            <Vote data={detail} action={actionSave} putDetail={putDetail} />
          ) : null}
          {[JudgeStatus.VOTE_DONE, JudgeStatus.DONE].includes(detail.judgeStatus) ? (
            <ViewVote data={detail} />
          ) : null}
        </div>
      </ApplyViewPage>
    </div>
  );
};

export const { Provider, useSimpleContext } = getSimpleContext({ hasReview: true });

const DetailProvider = (props) => (
  <Provider value={{ hasReview: props.hasReview }}>
    <Detail {...props} />
  </Provider>
);

export default DetailProvider;
